import * as React from 'react';
import {
  ListItemIcon,
  ListItemText,
  Grid, ListItem
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';

export const InnerItemList = ({ items, getScreenSize, isNameEditable,  handleDeleteClick, handleHoursChange, handleQtyChange, handleWattsChange }) => {

  return (
    items && items.length > 0 ? getScreenSize == 'S' ?
      items.map((item, index) => (
        <Grid item xs={12} key={index}>

          <ListItem
            sx={{
              border: '1px solid #ccc',
              borderRadius: 4,
              color: 'hsla( 150,94.93670886075948%,30.980392156862745% ,1)',
            }}
            classes={{ selected: item.isSelected }} // Conditionally apply 'selected' class
          >
            <Grid container direction="column" alignItems="center">
              <Grid item xs={6} key={index}>

                <Grid container direction="row" alignItems="center">
                  <ListItemIcon sx={{width:'41%'}} onClick={() => handleDeleteClick(item)}>
                    <DeleteIcon />
                  </ListItemIcon>

                  {isNameEditable ?
                  <TextField
                    value={item.primary} // Bind value to item's property
                    onChange={(e) => handleQtyChange(item, e.target.value)}
                    sx={{  width : '51%', mt: 2 }} // Add margin for spacing
                    inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
                  />
                  : <ListItemText sx={{ width: '41%' }} primary={item.primary} />
                }

                </Grid>
                <Grid container direction="row" alignItems="baseline">
                  <ListItemText sx={{ maxWidth: '41%' }} secondary={'Quantity'} />
                  <TextField
                    value={item.quantity} // Bind value to item's property
                    onChange={(e) => handleQtyChange(item, e.target.value)}
                    sx={{  width : '51%', mt: 2 }} // Add margin for spacing
                    inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
                  />

                </Grid>
                <Grid container direction="row" alignItems="baseline">
                  <ListItemText sx={{ maxWidth: '41%' }} secondary={'Running Watts'} />
                  <TextField
                    value={item.runningWatts} // Bind value to item's property
                    onChange={(e) => handleWattsChange(item, e.target.value)}
                    sx={{  width : '51%', mt: 2 }} // Add margin for spacing
                    inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
                  />
                </Grid>
                <Grid container direction="row" alignItems="baseline">
                  <ListItemText sx={{ maxWidth: '41%' }} secondary={'Hours Per Day'} />
                  <TextField
                    value={item.hoursPerDay} // Bind value to item's property
                    onChange={(e) => handleHoursChange(item, e.target.value)}
                    sx={{  width : '51%', mt: 2 }} // Add margin for spacing
                    inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
                  />
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
        </Grid>

      ))
      :
      items.map((item, index) => (
        <Grid item xs={12} key={index}>
          <ListItem

            sx={{
              border: '1px solid #ccc',
              borderRadius: 4,
              color: 'hsla( 150,94.93670886075948%,30.980392156862745% ,1)',
            }}
            classes={{ selected: item.isSelected }} // Conditionally apply 'selected' class
          >
            <Grid item xs={6} key={index}>
              <ListItemIcon onClick={() => handleDeleteClick(item)}>
                <DeleteIcon />
              </ListItemIcon>
              <ListItemText primary={item.primary} />
            </Grid>
            <Grid container direction="column" alignItems="center">
              <ListItemText secondary={'Quantity'} />
              <TextField
                value={item.quantity} // Bind value to item's property
                onChange={(e) => handleQtyChange(item, e.target.value)}
                sx={{ mt: 2 }} // Add margin for spacing
                inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
              />
            </Grid>
            <Grid container direction="column" alignItems="center">
              <ListItemText secondary={'Running Watts'} />
              <TextField
                value={item.runningWatts} // Bind value to item's property
                onChange={(e) => handleWattsChange(item, e.target.value)}
                sx={{ mt: 2 }} // Add margin for spacing
                inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
              />
            </Grid>
            <Grid container direction="column" alignItems="center">
              <ListItemText secondary={'Hours Per Day'} />
              <TextField
                value={item.hoursPerDay} // Bind value to item's property
                onChange={(e) => handleHoursChange(item, e.target.value)}
                sx={{ mt: 2 }} // Add margin for spacing
                inputProps={{
                  inputMode: 'numeric', // Display numeric keyboard on mobile
                  required: true, // Make the field required
                  min: 1, // Set the minimum value to 1
                  max: 24, // Set the maximum value to 24
                }} />
            </Grid>


          </ListItem>
        </Grid>
      )) : <></>

  );
};
